import React, { useState } from "react";
import { Box, Breadcrumbs, Link, Menu, MenuItem } from "@mui/material";
import { useUserData } from "../../context/userContext";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { selectGroup } from "../../state/snapshot/snapshotSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useSafes } from "../../hooks/useSafes";

type TSafeElement = { address: string; name: string };

const CustomBreadcrumbs = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { name, address, userSnapshot } = useUserData();
  const { data: safesData } = useSafes(address, userSnapshot?.safes?.length > 0);

  const selectedSnapshot = useAppSelector((state) => state.snapshot.data);

  const selectedGroup = useAppSelector((state) => state.snapshot.selectedGroup);

  const [safeAnchorEl, setSafeAnchorEl] = useState<null | HTMLElement>(null);
  const [groupAnchorEl, setGroupAnchorEl] = useState<null | HTMLElement>(null);

  const handleSafeClick = (event: React.MouseEvent<HTMLElement>) => {
    setSafeAnchorEl(event.currentTarget);
  };

  const handleGroupClick = (event: React.MouseEvent<HTMLElement>) => {
    setGroupAnchorEl(event.currentTarget);
  };

  const handleSafeClose = () => {
    setSafeAnchorEl(null);
  };

  const handleGroupClose = () => {
    setGroupAnchorEl(null);
  };

  const handleSafeSelect = (safe: TSafeElement) => {
    navigate(`/portfolio/${safe.address}`);
    handleSafeClose();
  };

  const handleGroupSelect = (group: string) => {
    dispatch(selectGroup(group));
    handleGroupClose();
  };

  const currentPath = useLocation().pathname;

  const isSafeRelated = currentPath.includes("/portfolio") || currentPath.includes("/manage-safe");

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      <Link color="inherit" href="" onClick={(e) => e.preventDefault()}>
        {name}
      </Link>

      {selectedSnapshot && isSafeRelated && (
        <Box>
          <Link
            color="inherit"
            // href=""
            onClick={handleSafeClick}
          >
            {selectedSnapshot.name}
          </Link>
          <Menu anchorEl={safeAnchorEl} open={Boolean(safeAnchorEl)} onClose={handleSafeClose}>
            {safesData?.map((safe) => (
              <MenuItem key={safe.address} onClick={() => handleSafeSelect(safe)}>
                {safe.name}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      )}
      {selectedSnapshot && isSafeRelated && (
        <Box>
          <Link color="inherit" sx={{ cursor: "pointer" }} onClick={handleGroupClick}>
            {selectedGroup !== null
              ? selectedSnapshot?.groups.find((group) => selectedGroup === group.id)?.name
              : "Choose Group"}
          </Link>
          <Menu anchorEl={groupAnchorEl} open={Boolean(groupAnchorEl)} onClose={handleGroupClose}>
            {selectedSnapshot?.groups.map((group) => (
              <MenuItem key={group.id} onClick={() => handleGroupSelect(group.id)}>
                {group.name}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      )}
    </Breadcrumbs>
  );
};

export default CustomBreadcrumbs;
